import { useAppState } from "AppState";
import Button from "components/common/Button/Button";
import Container from "components/common/Grid/Container";
import Header from "components/common/PanelLayout/Header/Header";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import Title from "components/common/Title";
import Widget from "components/common/Widget";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import strings from "static/strings.js";

interface IProp {
  history: {
    goBack: () => void;
  };
}

const CompletePurchase = ({ history }: IProp) => {
  const { locationName } = useAppState();

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Complete Purchase"
      backButtonHandler={history.goBack}
    >
      <Container>
        <Row justify="center">
          <Col sm={11}>
            <Widget text white>
              <Title noMargin>
                Please give the tablet to the {strings.cashier} to complete your
                purchase!
              </Title>
              <Link to="/budtender">
                <Button tertiary wide>
                  Next
                </Button>
              </Link>
            </Widget>
          </Col>
        </Row>
      </Container>
    </PanelLayout>
  );
};

export default CompletePurchase;



// WEBPACK FOOTER //
// ./src/screens/CompletePurchase/index.tsx